import { InputHTMLAttributes, forwardRef, PropsWithChildren } from 'react';
import { clsx } from 'clsx';
import { CheckIcon } from '@/shared/design-system/thermal-ceramics/icons';

import classNames from './styles.module.css';

export type CheckboxProps = PropsWithChildren<InputHTMLAttributes<HTMLInputElement>>;

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => {
  const { children, ...attributes } = props;

  return (
    <label
      className={clsx(classNames.checkbox, {
        [classNames.invalid]: props['aria-invalid'] === 'true' || props['aria-invalid'] === true,
      })}
    >
      <input
        {...attributes}
        ref={ref}
        className={classNames.input}
        type="checkbox"
      />
      <span className={classNames.check} aria-hidden="true">
        <CheckIcon className={classNames.icon} />
      </span>
      {children && <span className={classNames.label}>{children}</span>}
    </label>
  );
});